'use strict';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import * as ReactRedux from 'react-redux';
import Store from '../../redux/store.js';

const app = document.getElementById('sidebar-section');

if (app !== null) {
    var SidebarLayout = require('../../views/layouts/sidebar').SidebarLayout;
    const store = Store.createSidebarStore(window.REDUX_DATA);
    hydrateRoot(
        app,
        <ReactRedux.Provider store={store}>
            <SidebarLayout />
        </ReactRedux.Provider>
    );
}
